var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcReport = function SvgIcReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A312B",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M5 2h8l5 5v12c0 .55-.45 1-1 1H5c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A312B",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M13 2v5h5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2A312B",
    strokeLinecap: "round",
    strokeWidth: 1.8,
    d: "M7.5 16v-4m3.5 4V9.5m3.5 6.5v-3"
  })));
};
export { SvgIcReport as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMkgxM0wxOCA3VjE5QzE4IDE5LjU1IDE3LjU1IDIwIDE3IDIwSDVDNC40NSAyMCA0IDE5LjU1IDQgMTlWM0M0IDIuNDUgNC40NSAyIDUgMloiIHN0cm9rZT0iIzJBMzEyQiIgc3Ryb2tlLXdpZHRoPSIxLjgiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzIDJWN0gxOCIgc3Ryb2tlPSIjMkEzMTJCIiBzdHJva2Utd2lkdGg9IjEuOCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy41IDE2VjEyTTExIDE2VjkuNU0xNC41IDE2VjEzIiBzdHJva2U9IiMyQTMxMkIiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";